import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  editItemPolicy,
  editItemPrivacy,
  fetchDataPrivacy,
  fetchId,
  fetchIdNoPolicyloading,
  fetchIdNoloading,
  fetchIdPolicy,
  selectId,
  selectIdPolicy,
  selectIdPrivacy,
  selectLoading,
} from "./settingSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  checkEmptyFields,
  showDialog,
  paramsMasterAll,
  setOptionsMaster,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import cellEditFactory from "react-bootstrap-table2-editor";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";

export const PrivacyPolicyCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdPrivacy);

  const { id } = useParams();

  console.log(dataId, "dataId");

  const [value, setValue] = useState("");
  const [remarks, setRemarks] = useState("");
  const [templateId, setTemplateId] = useState("");
  const [template, setTemplate] = useState("");

  const paramsId = {
    company_policy_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchDataPrivacy());
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setTemplateId(dataId?.privacy_policy_id);
      setTemplate(dataId?.privacy_policy_rules);
    }
  }, [dataId]);

  const handleSave = async () => {
    const params = {
      privacy_policy_id: templateId,
      privacy_policy_rules: template,
    };
    try {
      const response = await dispatch(editItemPrivacy(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        await dispatch(fetchDataPrivacy());
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const theme = "snow";

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined
              ? "Edit Template Privacy Police"
              : "Edit Template Privacy Police"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div style={{ padding: "20px" }}>
            <ReactQuill
              theme={theme}
              onChange={(e) => {
                setTemplate(e);
              }}
              value={template}
              modules={modules}
              formats={formats}
            />
          </div>
        </CardBody>
      </Card>
    </>
  );
};
